"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkersProperty = exports.videoMarkersPropertyDefinition = void 0;
exports.videoMarkersPropertyDefinition = {
    name: 'video-markers',
    type: 'container',
    multiple: true,
    view: { label: 'Video markers' },
    constraints: [
        {
            name: 'properties',
            argument: ['video-marker'],
        },
    ],
};
const isVideoMarkersProperty = (prop) => {
    return prop.name === exports.videoMarkersPropertyDefinition.name && prop.type === exports.videoMarkersPropertyDefinition.type;
};
exports.isVideoMarkersProperty = isVideoMarkersProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2Vycy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3ZpZGVvLW1hcmtlcnMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsZUFBZTtJQUNyQixJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxlQUFlLEVBQUU7SUFDaEMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxjQUFjLENBQUM7U0FDM0I7S0FDRjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDL0csQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=